import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DashboardPage } from '../../features/dashboard/DashboardPage';

export const Route = createFileRoute('/_protected/dashboard')({
  validateSearch: z.object({ nodeKey: z.string().optional() }),
  component: DashboardPage,
});
